import GroupCardContentContainer from './GroupCardContentContainer';

export default GroupCardContentContainer;
